module.exports = __webpack_public_path__ + "media/bootstrap-icons/bookmark-star-fill-374a3e2e.svg";